import * as sidebar from "../../sidebar/index";

export function init() {
	const $list = $('#articlesList');
    itemSizeSpot();
	sidebar.init({
		heightTarget: $list
	});

	$list.zInfiniteScroll({
		selector: '[rel=page]',
		loading: '#pagesScrollLoader',
		maxAutoloadPages: 200,
		totalCount: $list.data('totalCount'),
		fetch: (page, callback) => {
			const data = {
				page: page,
				type: $list.data('blogType'),
				category: $list.data('blogCategory'),
			};
			$.get($list.data('loadUrl'), data, null, 'json')
				.done(response => {
					const $blocks = $(response['html']).filter('[rel=page]');
					callback($blocks);
				});
		}
	});

    $(window).resize(function(){
        itemSizeSpot();
    });
}

function itemSizeSpot(){
	let $items = $('.articles-list').find('.post');
    let width = $items.find('.content').innerWidth();

    if( width > 254){
        $items.attr('size', 'large');
    }

    if( width <= 254 && width >= 240){
        $items.attr('size', 'medium');
    }

    if( width >= 208 && width < 240){
        $items.attr('size', 'small');
    }
    if( width < 208){
        $items.attr('size', 'extra-small');
    }
}


// WEBPACK FOOTER //
// ./modules/blog/list/article/index.js